import { Component, OnInit } from '@angular/core';
import {
  PersonGbSearchErweitertRequest,
  PersonGbSearchErweitertRequestMeta,
  PersonGbSearchStandardRequest,
  PersonStammMasterListEntryMeta
} from '../../../core/gb-api';
import { ActivatedRoute } from '@angular/router';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ComparatorService } from '../../../shared/services/comparator-service';
import { LinkComponent, NavTarget } from '../../../shared/components/link/link.component';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { TableSortModel } from '../../../shared/tablesort/tableSortModel';
import { PersonstammListResolver } from './personstamm-list-resolver';
import { EigentuemerAuszugSettingsComponent } from '../../../shared/components/auszug/settings/eigentuemer-auszug-settings.component';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { AuszugSettingsService } from '../../../shared/components/auszug/settings/auszug-settings-service';
import { AuszugPrintService } from '../../../shared/components/auszug/auszug-print-service';
import { GbPrintService } from '../../../core/services/app-print.service';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../../shared/components/title-functionbar/title-functionbar.component';
import { FunctionbarSearchresultButtonsComponent } from '../../../shared/components/title-functionbar/functionbar-searchresult-buttons/functionbar-searchresult-buttons.component';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { ColumnHeaderComponent } from '../../../shared/tablesort/sort-icon/column-header.component';
import { KompaktStammpersonComponent } from '../../../shared/kompaktdarstellung/stammperson/kompakt-stammperson.component';
import { KompaktPersonenadresseComponent } from '../../../shared/kompaktdarstellung/personenadresse/kompakt-personenadresse.component';
import { PersonRolleCountComponent } from './person-rolle-count/person-rolle-count.component';
import { AuszugComponent } from '../../../shared/components/auszug/auszug.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipPersonstammPipe } from '../../../shared/pipes/simple/tooltip-personstamm.pipe';
import { PersonStammMasterDetailEntryMeta } from '../../../core/personstamm-api';
import { AppPermissionService } from '../../../core/services/app-permission.service';
import { PermissionResponse } from '../../../core/base-api';
import rollenEnum = PersonGbSearchErweitertRequestMeta.RolleEnum;
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Component({
  selector: 'cap-personstamm-list',
  templateUrl: './personstamm-list.component.html',
  styleUrls: ['./personstamm-list.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    FunctionbarSearchresultButtonsComponent,
    ListLoaderWrapperComponent,
    ColumnHeaderComponent,
    LinkComponent,
    KompaktStammpersonComponent,
    KompaktPersonenadresseComponent,
    NgbTooltip,
    PersonRolleCountComponent,
    AuszugComponent,
    TranslatePipe,
    TooltipPersonstammPipe
  ]
})
export class PersonstammListComponent implements OnInit {
  rolle: PersonGbSearchErweitertRequestMeta.RolleEnum;
  listLoader: ListLoader<PersonStammMasterListEntryMeta>;
  tableSortModel = new TableSortModel<PersonStammMasterListEntryMeta>('table', this.comparator);
  sortedRelevantList: Array<PersonStammMasterListEntryMeta>;
  selectedIds = [];
  allCheckboxesSelected = false;
  hasPermissionAuskunft: boolean = false;
  hasPermissionAdresse: boolean = false;

  constructor(
    private route: ActivatedRoute,
    protected comparator: ComparatorService,
    private personstammListResolver: PersonstammListResolver,
    private modalService: NgbModal,
    private permissionService: AppPermissionService,
    private auszugSettingsService: AuszugSettingsService,
    private auszugService: AuszugPrintService,
    public gbPrintService: GbPrintService
  ) {
    keysToTranslate<string>([
      'tooltip.EIGENTUEMER',
      'tooltip.UEBRIGE_BERECHTIGTE',
      'tooltip.GLAEUBIGER_SCHULDNER',
      'tooltip.detailsPersonGb',
      'tooltip.detailsPersonStamm',
      'suchergebnis.EIGENTUEMER',
      'suchergebnis.UEBRIGE_BERECHTIGTE',
      'suchergebnis.GLAEUBIGER_SCHULDNER',
      'KeineBerechtigungFuer',
      'berechtigtePersonen',
      'rolle'
    ]);
    this.hasPermissionAuskunft = this.permissionService.hasPermission(PermissionsEnum.AUSKUNFTSPERRE);
    this.hasPermissionAdresse = this.permissionService.hasPermission(PermissionsEnum.ADRESSSPERRE);
  }

  getNavTarget(): Map<PersonGbSearchErweitertRequestMeta.RolleEnum, NavTarget> {
    return new Map([
      [rollenEnum.EIGENTUEMER, NavTarget.NAV_PERSON_EIGENTUEMER_VERHAELTNISSE],
      [rollenEnum.UEBRIGE_BERECHTIGTE, NavTarget.NAV_PERSON_UEBRIGEBERECHTIGTE],
      [rollenEnum.GLAEUBIGER_SCHULDNER, NavTarget.NAV_PERSON_GLAEUBIGERAUSZUG],
      [rollenEnum.ALLE, NavTarget.NAV_PERSON_STAMM]
    ]);
  }

  ngOnInit() {
    const searchRequest = <PersonGbSearchErweitertRequestMeta>(JSON.parse(this.route.snapshot.queryParams.request) || {});
    this.rolle = searchRequest.rolle;
    this.listLoader = this.route.snapshot.data.listLoader;
    this.tableSortModel.addColumn(
      'personStammBezeichnung',
      this.bezeichnungSortFn,
      PersonGbSearchErweitertRequest.PersonStammSortEnum.BEZEICHNUNG
    );
    this.tableSortModel.addColumn('personStammArt', this.artSortFn, PersonGbSearchErweitertRequest.PersonStammSortEnum.ART);
    const tableSortModel = this.tableSortModel;
    this.personstammListResolver.listLoader$.subscribe((l) => {
      this.listLoader = l;
      this.listLoader?.applySortModel(tableSortModel);
      this.sortResultByRelevance(searchRequest);
    });
  }

  onAuszug() {
    this.openAuszugSettings(this.selectedIds);
  }

  removeAllCheckboxes() {
    const selectAllCheckbox = document.querySelector('#selectAllCheckbox') as HTMLInputElement;
    if (selectAllCheckbox) {
      selectAllCheckbox.checked = false;
    }
    this.selectedIds = [];
  }

  selectAllCheckboxes(items: Array<PersonStammMasterListEntryMeta>, event: any) {
    this.allCheckboxesSelected = !this.allCheckboxesSelected;
    for (const item of items) {
      this.addCheckedPerson(item.masterId.id, event);
    }
  }

  addCheckedPerson(id: string, event: any) {
    if (event.checked) {
      if (this.selectedIds.includes(id)) {
        return;
      }
      this.selectedIds.push(id);
    } else {
      this.selectedIds = this.selectedIds.filter((selectedId) => selectedId !== id);
    }
  }

  showPersonendaten(auskunftsperre: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum): boolean {
    let hasAuskunftsperre = auskunftsperre === PersonStammMasterDetailEntryMeta.AuskunftsperreEnum.AUSKUNFT_SPERRE;
    return !hasAuskunftsperre || (hasAuskunftsperre && this.hasPermissionAuskunft);
  }

  showAdressen(auskunftsperre: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum): boolean {
    let hasAdresssperre = auskunftsperre === PersonStammMasterDetailEntryMeta.AuskunftsperreEnum.ADRESS_SPERRE;
    return !hasAdresssperre || (hasAdresssperre && this.hasPermissionAdresse);
  }

  private bezeichnungSortFn = (a: PersonStammMasterListEntryMeta, b: PersonStammMasterListEntryMeta) => {
    return this.comparator.personStammComparator(a.version, b.version);
  };

  private artSortFn = (a: PersonStammMasterListEntryMeta, b: PersonStammMasterListEntryMeta) => {
    return this.comparator.orderByComparator(a.version.art, b.version.art);
  };

  private sortResultByRelevance(searchRequest: PersonGbSearchErweitertRequestMeta) {
    this.listLoader?.items$.subscribe((items) => {
      const withTerm = items?.filter((item) => this.containsTerm(item, searchRequest));
      const withoutTerm = items?.filter((item) => !this.containsTerm(item, searchRequest));
      this.sortedRelevantList = withTerm?.concat(withoutTerm);
    });
  }

  private containsTerm(item: PersonStammMasterListEntryMeta, searchRequest: PersonGbSearchStandardRequest): boolean {
    let adressInfo = '';
    for (let adresse of item.adressen) {
      adressInfo += [adresse.personAdresseArt, adresse.strasse, adresse.hausnummer, adresse.landCode, adresse.plz, adresse.ort].join(' ');
    }
    const personInfo = item.version.name + ' ' + adressInfo;
    if (searchRequest.suchbegriff) {
      return personInfo.toLowerCase().includes(searchRequest.suchbegriff.toLowerCase());
    }
    return false;
  }

  private openAuszugSettings(list) {
    const modalRef = this.modalService.open(EigentuemerAuszugSettingsComponent);
    modalRef.componentInstance.hasToZip = true;
    modalRef.componentInstance.ids = list;
    modalRef.componentInstance.indexNumber = 0;
  }
}
